import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { isEditor, isPreview } from '../../selectors/view-mode-selectors';
import { getAppData } from '../../selectors/app-data-selectors';
import { getCommonSettings } from '../../selectors/common-settings-selectors';
import { isPostPageBundle } from '../../services/section-route-utils';
import Message from '../../components/message';
import styles from './post-page-migration-message.scss';

const PostPageMigrationMessage = ({ isEditor, isPreview, appData, commonSettings, isPostPageBundle }) => {
  if (!(isEditor || isPreview)) {
    return null;
  }
  if (get(appData, 'postPageEnabled')) {
    return null;
  }
  if (!get(commonSettings, 'postPageEnabled')) {
    return null;
  }

  const className = classNames(styles.container, isPostPageBundle && styles.inPostPage);
  return (
    <div className={className} data-hook="post-page-migration-message">
      <Message
        content={t => t('post-page-migration.publish-site-message')}
        type="info"
        alignment="center"
        position="static"
      />
    </div>
  );
};

PostPageMigrationMessage.propTypes = {
  isEditor: PropTypes.bool,
  isPreview: PropTypes.bool,
  appData: PropTypes.object,
  commonSettings: PropTypes.object,
  isPostPageBundle: PropTypes.bool,
};

const mapStateToProps = state => ({
  isEditor: isEditor(state),
  isPreview: isPreview(state),
  appData: getAppData(state),
  commonSettings: getCommonSettings(state),
  isPostPageBundle: isPostPageBundle(),
});

export default connect(mapStateToProps)(PostPageMigrationMessage);
